import type { RootState } from '~/redux/store';
import type { User } from '~/types/models';

export const getCurrentUser = (state: RootState): User | null => state.auth.user;
